/**
 * REST ERP webhook contracts — Phase 3.
 *
 *   POST /erp/devices/{serial}/mark-sold
 *
 * Authentication: HMAC-SHA256 over raw request body.
 *   Header: X-ERP-Signature  — hex(hmac-sha256(ERP_WEBHOOK_SECRET, timestamp + '.' + rawBody))
 *   Header: X-ERP-Timestamp  — Unix epoch seconds (string); request rejected if |now - ts| > 300s
 */
import { z } from 'zod';
import { E164MobileSchema } from '../common/mobile.js';
import { Iso8601Schema } from '../common/timestamp.js';
export const ErpMarkSoldBody = z.object({
    soldAt: Iso8601Schema,
    orderRef: z.string().min(1).max(128).optional(),
    customerMobile: E164MobileSchema.optional(),
});
export const ErpMarkSoldResponse = z.object({
    serialNumber: z.string(),
    lifecycleState: z.literal('sold'),
    transitionedAt: Iso8601Schema,
});
//# sourceMappingURL=erp.js.map